import { Directive, ElementRef, inject, InjectionToken, OnDestroy, OnInit } from '@angular/core';

/** Receives the container of the Stripe Payment Element while it is in the DOM. */
export interface PaymentElementHostRegistry {
  attachPaymentHost(host: HTMLElement): void;
  detachPaymentHost(host: HTMLElement): void;
}

export const PAYMENT_ELEMENT_HOST_REGISTRY = new InjectionToken<PaymentElementHostRegistry>(
  'PAYMENT_ELEMENT_HOST_REGISTRY',
);

/**
 * Marks the element the Payment Element mounts into. The container comes and
 * goes with the payment step, so it reports itself instead of being queried.
 */
@Directive({
  selector: '[hypecastAdminPaymentElementHost]',
  standalone: true,
})
export class PaymentElementHostDirective implements OnInit, OnDestroy {
  private readonly element = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly registry = inject(PAYMENT_ELEMENT_HOST_REGISTRY);

  ngOnInit(): void {
    this.registry.attachPaymentHost(this.element.nativeElement);
  }

  ngOnDestroy(): void {
    this.registry.detachPaymentHost(this.element.nativeElement);
  }
}
